export default __webpack_public_path__ + "b9857203de68e4b650499ca3c1473a55.png";